import React, { useState } from 'react';

import { language } from './Language'

import {
    get_language,

} from '../../../Utils';
import Company from './Init';
import { NavLink } from 'react-router-dom';

/* let lista1 = [{ id: 1, nome: 'S' }, { id: 2, nome: 'M' }, { id: 3, nome: 'L' }]

let lista2 = [
{ id: 4, nome:'Azul' },
{ id: 5, nome:'Branco' },
{ id: 6, nome:'Preto' },
{ id: 7, nome:'Verde' },
{ id: 8, nome:'Vermelho'}
]

let lista3 = [ { id: 9, nome: 'Estampagem_1' }, { id: 10, nome: 'Estampagem_2' }] */

//let lista4 = [{ id: 20, nome: 'Capuz' }, { id: 21, nome: 'Sem Capuz' }]


/* let combina = (lista_arrays ) =>{


    if (lista_arrays.length === 1){

        console.log('resultado:', lista_arrays)
        return lista_arrays
    }
    var first, second, rest;
    [first, second, ...rest] = lista_arrays

    console.log('first:', first)
    console.log('second:', second)
    let tmp = first.flatMap(d => second.map(v =>  d.length >0 ?  [...d, v] :  [d, v]))
    console.log('flatMap:', tmp)

    let new_lista = [...rest,tmp].reverse()

    console.log('new_lista:', new_lista)
   
    combina(new_lista )
    
 

} 
 */


export default function View(props) {

    const [lang,] = useState(get_language());





    return (
        <main>
            <div className={`dash-cards-2 header`}>
                <h2 className="dash-title">{language(lang).Company.name}</h2>
                <p><>
                    <NavLink to={'/'}>{language(lang).Company.path_home}</NavLink>{' / '}
                    <NavLink to={Company.components.base.path}>{language(lang).Company.name}</NavLink>{' / '}
                    {language(lang).Company.path_view}
                </>
                </p>
            </div>

            <div className={`dash-cards-2 highlights`}>
                
                <div className="card-single">
                    <div className="card-body">
                        <div>
                            <h5>{language(lang).main.view.dash_card_title}</h5>
                      {/*       <h5>[{lista1.map((a, k) => k === lista1.length - 1 ? a.nome : `${a.nome},`)}]</h5>
                            <h5>[{lista2.map((a, k) => k === lista2.length - 1 ? a.nome : `${a.nome},`)}]</h5>
                            <h5>[{lista3.map((a, k) => k === lista3.length - 1 ? a.nome : `${a.nome},`)}]</h5> */}
                            
                        </div>
                    </div>
                </div>


                <div className="card-single">
                    <div className="card-body">
                        <div>
                          {/*   <h5>Combinações</h5>
                            <h5>{combina([lista1, lista2, lista3, lista4])}</h5> */}
                          
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}
